// extracted by mini-css-extract-plugin
export default {"learnMoreLinks":"LearnMoreLinks_learnMoreLinks__XJZB2","learnMoreLink":"LearnMoreLinks_learnMoreLink__ANwfB"};